import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

import { ISubNavCollection } from './sub.nav.horizonal.interface';

@Component({
    selector: 'mlp-ng-sub-nav-horizontal',
    templateUrl: './sub.nav.horizontal.component.html',
    styleUrls: ['./sub.nav.horizontal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SubNavHorizontalSharedComponent {
    @Input() links: ISubNavCollection;

    @Input() rightButtonLabel: string;
    @Input() rightButtonIcon: string;
    @Output() rightButtonAction = new EventEmitter();

    rightButtonClick(): void {
        this.rightButtonAction.emit();
    }
}
